import axios from "axios";

const envBase = process.env.REACT_APP_BACKEND_URL;
const originMismatch = typeof window !== "undefined" && envBase &&
  new URL(envBase).origin !== window.location.origin;
export const API = originMismatch ? "/api" : `${envBase}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config || {};
    const url = original.url || "";
    if (error.response?.status === 401 && !original._retried && !url.startsWith("/auth/")) {
      original._retried = true;
      try {
        refreshing = refreshing || axios.post(`${API}/auth/refresh`, {}, { withCredentials: true }).finally(() => { refreshing = null; });
        await refreshing;
        return api(original);
      } catch { /* refresh failed — surface the original 401 */ }
    }
    return Promise.reject(error);
  }
);

export function fmtErr(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const fmtRent = (r) => (r ? `$${Number(r).toLocaleString()}` : "N/A");

export const bedsLabel = (l) => (l.is_studio || l.beds === 0 ? "Studio" : `${l.beds} bed`);

export function getVisitorId() {
  let v = localStorage.getItem("tendly-vid");
  if (!v) {
    v = crypto.randomUUID();
    localStorage.setItem("tendly-vid", v);
  }
  return v;
}

export function trackEvent(type, extra = {}) {
  try {
    api.post("/analytics/event", { type, visitor_id: getVisitorId(), ...extra }).catch(() => {});
  } catch { /* analytics must never break the app */ }
}
